import React, { useEffect, useState } from 'react';
import { shallowEqual } from 'react-redux';
import { fetchSiteList, getLastWebsiteAudit, selectedSite, useAppDispatch, useAppSelector } from 'src/store';
import { redirect, useNavigate } from 'react-router-dom';
import { AutomatedAuditLoader, Button } from '@common/components';
import { Flex, Space, Tooltip } from '@mantine/core';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { apiInstance } from 'src/services';
import { useTranslation } from 'react-i18next';
import { Lock } from '@geist-ui/icons';
import AddSiteForm from 'src/components/forms/AddSiteForm';
import { useAlert } from '@common/hooks';
import AddSiteFormIssuePage from 'src/components/forms/AddSiteForm/issuePageForm';
import { PATHS } from 'src/constants';


function InitSelectWebsite() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const selectedSiteData = useAppSelector((state) => state.site.selectedSiteData, shallowEqual);
  const sitesArray = useAppSelector((state) => state.siteList.data);
  const { websiteCount } = useAppSelector((state) => state.user.data, shallowEqual);
  const { lastSiteAuditedData, loadinglastSiteAudited , lastSiteAuditedError } = useAppSelector((state) => state.siteList, shallowEqual);
  const [ showAddSite , setShowAddSite ] = useState(false);
  useEffect(() => {
    // dispatch(getLastWebsiteAudit());
    dispatch(fetchSiteList({isLatest:true}));
  }, []);
  
  useEffect(() => {
   
    // if (lastSiteAuditedData) {
    //   const site = lastSiteAuditedData?.data?.siteData?.body?.lastUpdatedWebsite
    //   if (site) {
    //     localStorage.setItem('selectedSite', JSON.stringify(site));
    //     dispatch(selectedSite({ selectedSiteData: site }));
    //     navigate(`/dashboard/${site?.site_id}/issues/automated-audit?siteUUID=${site?.id}&pageNumber=1`);
    //     return
    //   }
    // }
    if(sitesArray['Latest'] && sitesArray['Latest'].length){
      const site = sitesArray['Latest'][0];
      if (site) {
        localStorage.setItem('selectedSite', JSON.stringify(site));
        dispatch(selectedSite({ selectedSiteData: site }));
        navigate(`/dashboard/${site?.site_id}/issues/automated-audit?siteUUID=${site?.id}&pageNumber=1`);
        return
      }
    }

    // If no last audited site and no sites array, show add site.
    setShowAddSite(true);
}, [lastSiteAuditedData, selectedSiteData, navigate, sitesArray]);

  const { isLoading } = useAppSelector((state) => state.payment);
  const loading = useAppSelector((state) => state.siteList.loading);
  
  const { websites } = useAppSelector((state) => state.payment.data.metadata);
  const [addSite, setAddSite] = useState(false);
  const changeFormState = (value:string): void => {
    setAddSite(!addSite);
    if ( value !== 'cancel') {  
      navigate(PATHS.AUTOMATED_AUDIT_SELECT);
    }

  }
  const canDisplayButton = !( websiteCount  >= Number(websites)) && !isLoading;

  const navigateToPayment = (): void => {
    // if(!hasPermission){
    //       return;
    //   }
    apiInstance.get('payment/portal').then((res) => {
      window.location = res.data.url;
    });
  };
  const [c] = useTranslation('common');
  const [t] = useTranslation('siteList');
  const siteLists = useAppSelector((state) => state.siteList.data, shallowEqual);
  // const user = useAppSelector((state) => state.user, shallowEqual);
  
  return (
    <Flex style={{ width : 'calc(100% - 300px)'}} h={"100%"} justify={"center"} align={"center"} direction={'column'}>
      {
        loadinglastSiteAudited || loading  ? <>
          <AutomatedAuditLoader />
          <p>Loading Issues</p>
        </> :
           showAddSite  && (
          <>
            <Flex>No websites have been added.</Flex>
            <Space h="lg" />

          {  !addSite && (
            <>
              <Button
                className={classNames({ [styles['link-btn']]: !loading && !canDisplayButton })}
                id={'addSiteButton'}
                loading={loading}
                ariaLabel={!loading && !canDisplayButton ? `${c('myPlan')} ${c('opensInNewTabLink')}` : ''}
                // disabled={!hasPermission}
                onClick={() => (!canDisplayButton ? navigateToPayment() : setAddSite(true))}>
                {
                  !loading && !canDisplayButton ?
                    <Tooltip label="The Maximum Site Limit Has Been Reached">
                      <Flex gap={'5px'}>
                        {(!loading && !canDisplayButton) && <Lock size={16} aria-label="locked item" />}
                        {t('addSiteBtn')}
                      </Flex>
                    </Tooltip> :
                    t('addSiteBtn')
                }
              </Button>
            </>
            )}

          {  addSite && (
            <div style={{width:'60%'}}>
              <AddSiteFormIssuePage
                isAccountPage={true}
                style={{ alignItems: 'end'}}
                
              changeFormState={changeFormState} listItems={siteLists} canDisplayButton={canDisplayButton}   />
            </div>
            )}
          </>
        )
      }
    </Flex>

  );
}


export default InitSelectWebsite